import { LoadScriptProps, useLoadScript } from "@react-google-maps/api";
import { AutoComplete, Input, Select } from "antd";
import pinPng from "assets/image/pin.png";
import { AppContext } from "providers/app-context";
import { useContext } from "react";
import usePlacesAutocomplete, { getDetails } from "use-places-autocomplete";
import styles from "./../index.module.scss";

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
const GOOGLE_MAPS_API_LIBRARY: LoadScriptProps['libraries'] = ["places"]

const CountryList = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua & Deps", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Central African Rep", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Congo {Democratic Rep}", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland {Republic}", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea North", "Korea South", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar, {Burma}", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russian Federation", "Rwanda", "St Kitts & Nevis", "St Lucia", "Saint Vincent & the Grenadines", "Samoa", "San Marino", "Sao Tome & Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad & Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"];

const CountryInputBox = () => {
  const {setMailingAddressCountry} = useContext(AppContext)
  return (
    <div className={`${styles.companyMailingAddressLineContainer}`}>
      <div className={`${styles.descriptionCountry}`}>Select Country</div>
      <Select
          style={{ width: "72%", padding: "2px", backgroundColor: "white", marginTop: "0px"}}
          options={CountryList.map((country)=>({label: country, value: country}))}
          className={`${styles.companyMailingAddressInputBox}`}
          bordered={false}
          onChange={(value)=>setMailingAddressCountry(value)}
      />
    </div>
  )
}

const PlacesAutocomplete = () => {
  const {
    value,
    setValue,
    suggestions: { data },
    clearSuggestions,
  } = usePlacesAutocomplete({debounce:1000});

  const { 
    mailingAddressCountry,
    setMailingAddress,
    mailingAddressCity,
    setMailingAddressCity,
    mailingAddressState,
    setMailingAddressState,
    mailingAddressZipcode,
    setMailingAddressZipcode,
    mailingAddressAptNumber,
    setMailingAddressAptNumber
  } = useContext(AppContext);
  
  const handleSelect = (selectedValue: string, selectedOption: any) => {
    const placeID = selectedOption['lable'];
    const parameter = {
      placeId: placeID,
      fields: ["formatted_address"]
    };
    getDetails(parameter)
      .then((details) => {
        if (typeof details !== 'string' && details["formatted_address"]){
          const addressList = details["formatted_address"].split(', ');
          const streetName = addressList? addressList[0] : "";
          const cityName = addressList? addressList[1] : "";
          const stateName = addressList? addressList[2].split(' ')[0] : "";
          const zipCode = addressList? addressList[2].split(' ')[1] : "";
          setValue(streetName, false);
          setMailingAddress(streetName)
          setMailingAddressCity(cityName)
          setMailingAddressState(stateName)
          setMailingAddressZipcode(zipCode)
        } 
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
    
      clearSuggestions();
  };

  return (
    <div className={`${styles.formInputContainer} ${styles.formTextInput}`} style={{ height: "300px" }}>
      <CountryInputBox/>
      
      { mailingAddressCountry === "United States" && <div className={`${styles.companyMailingAddressLineContainer}`}>
        <div className={`${styles.descriptionStreet}`}>Street</div>
        <AutoComplete
          style={{ width: "86%" }}
          value={value}
          options={data.map(({place_id, description})=>({lable: place_id, value: description}))}
          onSelect={handleSelect}
          onChange={(newValue)=>{setValue(newValue); setMailingAddress(newValue)}}
        >
          <Input
              prefix={<img style={{ height: "20px", marginRight: "10px" }} src={pinPng} alt="pin" />}
              style={{ marginTop: "10px" }}
              className={`${styles.companyMailingAddressInputBox}`}
              placeholder="Write your mailing address here"
              autoFocus={true}
            />
        </AutoComplete>
      </div>}

      { mailingAddressCountry === "United States" && <div className={`${styles.companyMailingAddressLineContainer}`}>
        <div className={`${styles.descriptionStreet}`}>{"Apt/Unit # (Optional)"}</div>
        <Input
            style={{ marginTop: "10px", width: "62%", paddingTop: "3px" }}
            className={`${styles.companyMailingAddressInputBox}`}
            placeholder="Address Line 2"
            value={mailingAddressAptNumber}
            onChange={(e)=>setMailingAddressAptNumber(e.target.value)}
          />
      </div>}

      { mailingAddressCountry === "United States" && <div className={`${styles.companyMailingAddressLineContainer}`}>
        <div className={`${styles.descriptionStreet}`}>City</div>
        <Input
            style={{ marginTop: "10px", width: "90%", paddingTop: "3px" }}
            className={`${styles.companyMailingAddressInputBox}`}
            placeholder="City"
            value={mailingAddressCity}
            onChange={(e)=>setMailingAddressCity(e.target.value)}
          />
      </div>}

      { mailingAddressCountry === "United States" && <div className={`${styles.companyMailingAddressLineContainer}`}>
        <div className={`${styles.descriptionStreet}`}>State</div>
        <Input
            style={{ marginTop: "10px", width: "87%", paddingTop: "3px" }}
            className={`${styles.companyMailingAddressInputBox}`}
            placeholder="State"
            value={mailingAddressState}
            onChange={(e)=>setMailingAddressState(e.target.value)}
          />
      </div>}

      { mailingAddressCountry === "United States" && <div className={`${styles.companyMailingAddressLineContainer}`}>
        <div className={`${styles.descriptionStreet}`}>ZIP Code</div>
        <Input
            style={{ marginTop: "10px", width: "81%", paddingTop: "3px" }}
            className={`${styles.companyMailingAddressInputBox}`}
            placeholder="ZIP Code"
            value={mailingAddressZipcode}
            onChange={(e)=>setMailingAddressZipcode(e.target.value)}
          />
      </div>}

      { mailingAddressCountry !== "United States" && <div className={`${styles.companyMailingAddressLineContainer}`}>
        <div className={`${styles.descriptionStreet}`}>Address</div>
        <Input
            style={{ marginTop: "10px", width: "84%", paddingTop: "3px" }}
            className={`${styles.companyMailingAddressInputBox}`}
            placeholder="Write your mailing address here"
            onChange={(e)=>setMailingAddress(e.target.value)}
          />
      </div>}

    </div>
  );
};


const AddressInput = () => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_API_LIBRARY
  });
  return isLoaded ? <PlacesAutocomplete/> : <div>Loading...</div>;
}

export default AddressInput;
